import React from 'react'
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import StarRatingComponent from 'react-star-rating-component';

const AutoPlaySlider = withAutoplay(AwesomeSlider);

export const ReviewSlider = () =>
	<AutoPlaySlider play={true} cancelOnInteraction={false}
		interval={6000} organicArrows={false} showTimer={false}>
		<div className="review-box">
			<StarRatingComponent
				name="review-1"
				starCount={5}
				value={5} />
			<div className="review-text">
				“Massively above industry average clickthrough rate for a newsletter that almost creates itself!“
			</div>
			<div className="reviewer">
				Heather S. on G2
			</div>
		</div>
		<div className="review-box">
			<StarRatingComponent
				name="review-2"
				starCount={5}
				value={5} />
			<div className="review-text">
			“Depending on how you did your newsletter, rasa reduces the time by 90%.
			I feel like we added another staff person.“
			</div>
			<div className="reviewer">
				Mark C. from ISRI
			</div>
		</div>
		<div className="review-box">
			<StarRatingComponent
				name="review-3"
				starCount={5}
				value={5} />
			<div className="review-text">
				“The best newsletter system. The right info to the right people, automatically. Fantastic!“
			</div>
			<div className="reviewer">
				Juan R. on G2.com
			</div>
		</div>
	</AutoPlaySlider>
